export default {
  AutomationInputLoading: {
    mounted() {
      this.showTimeout = null;
      this.active = false;
      this.indicator = this.el.querySelector('[data-automation-loading-indicator]');

      this.handleEvent('automation_input_loading_start', payload => {
        if (!this.matchesPayload(payload)) return;
        this.start();
      });

      this.handleEvent('automation_input_loading_stop', payload => {
        if (!this.matchesPayload(payload)) return;
        this.stop();
      });
    },

    destroyed() {
      this.clearShowTimeout();
    },

    matchesPayload(payload) {
      const targetId = this.el.dataset.targetId;
      return targetId && payload?.id === targetId;
    },

    clearShowTimeout() {
      if (this.showTimeout) {
        clearTimeout(this.showTimeout);
        this.showTimeout = null;
      }
    },

    start() {
      this.active = true;
      this.clearShowTimeout();
      this.showTimeout = setTimeout(() => {
        this.showTimeout = null;
        if (this.active) this.show();
      }, 500);
    },

    stop() {
      this.active = false;
      this.clearShowTimeout();
      this.hide();
    },

    show() {
      if (!this.indicator) return;
      this.indicator.classList.remove('hidden');
      this.indicator.classList.add('flex');
    },

    hide() {
      if (!this.indicator) return;
      this.indicator.classList.add('hidden');
      this.indicator.classList.remove('flex');
    },
  },

  DelayedAnimation: {
    mounted() {
      this.showTimeout = null;
      this.isVisible = false;
      this.applyAnimationState();
    },

    updated() {
      this.applyAnimationState();
    },

    destroyed() {
      this.clearShowTimeout();
    },

    clearShowTimeout() {
      if (this.showTimeout) {
        clearTimeout(this.showTimeout);
        this.showTimeout = null;
      }
    },

    hide() {
      this.el.classList.add('hidden');
      this.el.classList.remove('flex');
      this.isVisible = false;
    },

    show() {
      this.el.classList.remove('hidden');
      this.el.classList.add('flex');
      this.isVisible = true;
    },

    applyAnimationState() {
      const isActive = this.el.dataset.active === 'true';
      const delayMs = Number.parseInt(this.el.dataset.delayMs || '1000', 10);
      const safeDelayMs = Number.isNaN(delayMs) ? 1000 : delayMs;

      if (isActive) {
        if (this.isVisible || this.showTimeout) return;

        this.showTimeout = setTimeout(() => {
          this.showTimeout = null;
          if (this.el.dataset.active === 'true') {
            this.show();
          }
        }, safeDelayMs);
      } else {
        this.clearShowTimeout();
        if (this.isVisible) {
          this.hide();
        }
      }
    },
  },
};
